import React, { createContext } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
var defaultTranslations = {
    exploreMap: 'Explore Map',
    mapTitle: 'Learning Across the Land',
    mapDescription: 'Hundreds of Indigenous language learning programs exist around the country. Click on the yellow dots to explore on-the-land learning, immersion, non-immersion, early childhood, in-school (K-12), and post-secondary language learning programs.',
    viewAllResources: 'View All Programs',
    viewResource: 'View Program',
    loadingResources: 'Loading programs...',
    resourcesInLocation: '{count} Programs in {location}',
    viewAllInLocation: 'View all programs in {location}',
    errorLoadingMap: 'Error loading map:',
    errorLoadingResources: 'Error loading programs:',
};
export var TranslationContext = createContext({
    translations: defaultTranslations,
    language: 'en'
});
var queryClient = new QueryClient();
document.addEventListener('DOMContentLoaded', function () {
    var _a, _b;
    var container = document.getElementById('resource-map-root');
    if (container) {
        var root = createRoot(container);
        var lang = ((_a = window.rmSettings) === null || _a === void 0 ? void 0 : _a.language) || 'en';
        var translations = ((_b = window.rmSettings) === null || _b === void 0 ? void 0 : _b.translations) || defaultTranslations;
        root.render(React.createElement(React.StrictMode, null,
            React.createElement(QueryClientProvider, { client: queryClient },
                React.createElement(TranslationContext.Provider, { value: { translations: translations, language: lang } },
                    React.createElement(App, null)))));
    }
});
